
import React, { useState ,useEffect } from 'react';
import CustomButton from './elements/CustomButton/CustomButton';
import CloseIcon from '@mui/icons-material/Close';

function DeleteConfirmation({ onClose , handleDelete ,dialogDetails ,type}) {
                       
         const onDelete = () => {
            if(handleDelete){
                handleDelete(dialogDetails.rowData.id)
            }
         }
         const onDeleteHandle = () => {
            if(handleDelete){
                handleDelete(dialogDetails.rowData)
            }
         }
    return (
        <div className="pt-6 px-10" >
            <div className="flex justify-between mb-6">
                <div className="flex justify-center w-full text-lg font-[500]" >{dialogDetails.title}</div>
                <button
                    className=" text-gray-600 hover:text-black"
                    onClick={onClose}
                    aria-label="Close"
                >
                    <CloseIcon />
                </button>
            </div>
            <div className='flex flex-col my-4 w-full justify-center items-center' >
                <div>{dialogDetails.content}</div>
                <div className="flex justify-center items-center mt-8 mb-4 gap-3">
                  {type === "setting" ?(
                    <CustomButton
                        onClick={() => onDeleteHandle()}
                        customeClass={`gradient-button w-full sm:w-[150px] h-[40px]`}
                    >
                        Delete
                    </CustomButton>
                  ) : (
                    <>
                       <CustomButton
                        onClick={onClose}
                        customeClass="primary-custom-button w-full sm:w-[150px] h-[40px]"
                    >
                        Cancel
                    </CustomButton>
                    <CustomButton
                        onClick={() => onDelete()}
                        customeClass={`gradient-button w-full sm:w-[150px] h-[40px]`}
                    >
                        Delete
                    </CustomButton></>
                  )}
                </div>
            </div>
        </div>
    );
}

export default DeleteConfirmation;